/* snoot: Gum Story engine. Three modes, picked in the section's settings:
   flip    = page flip lock. Once the sticky stage is pinned on a downward scroll the page is frozen in place
             (so a flick's momentum can't carry past it) and every wheel turn, swipe or arrow key flips ONE stage.
             The last flip, or the Skip link, releases the page. Scrolling back up through it never locks.
   deck    = swipe deck. Normal section, never locks. Arrows, a Next button, left/right swipes and dots flip stages.
   stories = tap story. Normal section, never locks. Plays itself (one stage every few seconds) while on screen,
             tap the right side for next, the left side for back, hold to pause.
   Photos crossfade, the text card fades, the risk meter steps. Drawn SVG scenes (fallback when a step has no
   picture) are driven by custom properties on the stage. */
(function () {
  var F = [96, 112, 850, 544], M = [118, 184, 196, 125];
  var BASE = { a: 0, b: 0, c: 0, cam: M, germs: 0, crust: 0, rec: 0, vessel: 0, body: 0, shield: 0, ping: 0 };
  var SCENES = {
    dog: { a: 1, cam: F, ping: 1 }, plaque: { b: 1, germs: 1 }, tartar: { b: 1, germs: 0.6, crust: 1 },
    gums: { c: 1, crust: 1, rec: 1 }, blood: { c: 1, crust: 1, rec: 1, vessel: 1 }, body: { a: 1, cam: F, body: 1 },
    fix: { b: 1, germs: 0, crust: 0.2, shield: 1 }
  };
  var KEYS = ['a', 'b', 'c', 'germs', 'crust', 'rec', 'vessel', 'body', 'shield', 'ping'];
  var WHEEL_FLIP = 60;   // normalised wheel delta that counts as one deliberate turn
  var SWIPE_FLIP = 70;   // px of finger travel that counts as one swipe (flip mode, vertical)
  var SWIPE_DECK = 44;   // px of sideways finger travel that counts as a swipe (deck mode)
  var GAP = 320;         // ms of quiet that ends a wheel gesture (so trackpad inertia can't double flip)
  var SETTLE = 1200;     // ms a release scroll gets before the section may catch the page again
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function scene(name) {
    var s = SCENES[name] || SCENES.dog, o = {};
    for (var k in BASE) o[k] = s[k] !== undefined ? s[k] : BASE[k];
    return o;
  }
  function wheelDelta(e) {
    var d = e.deltaY;
    if (e.deltaMode === 1) d *= 40; else if (e.deltaMode === 2) d *= window.innerHeight;
    return d;
  }
  function typing() {
    var a = document.activeElement;
    return a && (/^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) || a.isContentEditable);
  }

  function init(root) {
    if (root.__sgs) return;
    root.__sgs = true;
    var mode = root.getAttribute('data-mode') || 'flip';
    var track = root.querySelector('[data-sgs-track]'), stage = root.querySelector('[data-sgs-stage]');
    var dog = root.querySelector('[data-sgs-dog]'), cue = root.querySelector('[data-sgs-cue]'), skip = root.querySelector('[data-sgs-skip]');
    var art = root.querySelector('.sgs__art');
    var steps = [].slice.call(root.querySelectorAll('[data-sgs-step]'));
    var photos = [].slice.call(root.querySelectorAll('[data-sgs-photo]'));
    var dots = [].slice.call(root.querySelectorAll('[data-sgs-dot]'));
    var segs = [].slice.call(root.querySelectorAll('[data-sgs-seg]'));
    var tabs = [].slice.call(root.querySelectorAll('[data-sgs-tab]'));
    var clips = [].slice.call(root.querySelectorAll('.sgs__photo video'));
    var load = root.querySelector('[data-sgs-load]'), bar = root.querySelector('[data-sgs-bar]');
    var list = root.querySelector('.sgs__steps'), card = root.querySelector('[data-sgs-card]'), nums = [].slice.call(root.querySelectorAll('[data-sgs-num]')), num = nums[0] || null;
    var counter = root.querySelector('[data-sgs-counter]'), nextBtn = root.querySelector('[data-sgs-nextbtn]'), nextLabel = root.querySelector('[data-sgs-next-label]');
    var n = steps.length, on = -1, live = false;
    var onShow = null, onLive = null;
    if (!n) return;

    function show(i, silent) {
      if (i === on) return;
      var prev = on, fwd = i > prev;
      on = i;
      stage.setAttribute('data-dir', fwd ? 'fwd' : 'back');
      steps.forEach(function (s, k) { s.classList.toggle('is-prev', k === prev && fwd); });
      photos.forEach(function (p) { var k = +p.getAttribute('data-sgs-photo'); p.classList.toggle('is-prev', k === prev && fwd); p.classList.toggle('is-out', k === prev); });
      nums.forEach(function (el) { el.classList.add('is-pop'); setTimeout(function () { el.classList.remove('is-pop'); }, 300); });
      steps.forEach(function (s, k) { s.classList.toggle('is-on', k === i); s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      if (list) list.style.height = steps[i].offsetHeight + 'px';
      nums.forEach(function (el) { el.textContent = i + 1; });
      if (counter) counter.textContent = (i + 1) + ' / ' + n;
      if (card) card.setAttribute('data-scene', steps[i].getAttribute('data-scene'));
      photos.forEach(function (p) { p.classList.toggle('is-on', +p.getAttribute('data-sgs-photo') === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k <= i); d.classList.toggle('is-now', k === i); });
      tabs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); t.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
      playClips();
      segs.forEach(function (s, k) { s.classList.toggle('is-done', k < i); s.classList.toggle('is-now', k === i); if (k !== i) s.firstElementChild.style.width = k < i ? '100%' : '0%'; });
      var risk = parseInt(steps[i].getAttribute('data-risk'), 10) || 0;
      if (load) { var from = parseInt(load.textContent, 10) || 0, t0 = performance.now(); (function tick(now) { var p = Math.min(1, (now - t0) / 650); p = 1 - Math.pow(1 - p, 3); load.textContent = Math.round(from + (risk - from) * p) + '%'; if (p < 1 && on === i) requestAnimationFrame(tick); })(t0); }
      if (bar) bar.style.width = risk + '%';
      stage.setAttribute('data-risk-band', risk >= 70 ? 'high' : risk >= 35 ? 'mid' : 'low');
      if (cue) cue.classList.toggle('is-hidden', i >= n - 1);
      root.classList.toggle('is-last', i >= n - 1);
      root.classList.toggle('is-first', i <= 0);
      if (nextLabel) { var e = i < n - 1 ? steps[i + 1].querySelector('.sgs__eyebrow') : null; nextLabel.textContent = e ? e.textContent : ''; }
      var v = scene(steps[i].getAttribute('data-scene'));
      KEYS.forEach(function (k) { stage.style.setProperty('--' + k, v[k]); });
      if (dog) dog.setAttribute('viewBox', v.cam.join(' '));
      if (!silent && typeof onShow === 'function') onShow(i);
    }

    function playClips() {
      // only the stage on screen plays; the rest rewind so a flip back starts clean
      if (!live) { var rr = root.getBoundingClientRect(); if (rr.bottom > -300 && rr.top < window.innerHeight + 300) { live = true; root.classList.add('is-live'); } }
      clips.forEach(function (v) {
        var k = +v.closest('[data-sgs-photo]').getAttribute('data-sgs-photo');
        if (k === on && live) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
        else if (k !== on) { v.pause(); try { v.currentTime = 0; } catch (e) {} }
      });
    }
    function stickyTop() { return parseFloat(getComputedStyle(stage).top) || 0; }
    function trackPos() {
      var r = track.getBoundingClientRect();
      return { y: stickyTop() - r.top, travel: r.height - stage.offsetHeight, top: window.scrollY + r.top - stickyTop() };
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        live = es[0].isIntersecting;
        root.classList.toggle('is-live', live);
        if (live) photos.forEach(function (p) { [].forEach.call(p.querySelectorAll('img'), function (im) { im.loading = 'eager'; }); });
        if (live) playClips(); else clips.forEach(function (v) { v.pause(); });
        if (typeof onLive === 'function') onLive(live);
      }, { rootMargin: '300px 0px' }).observe(root);
    } else { live = true; root.classList.add('is-live'); }
    // fallback: some phones never report the section as on screen, so the clip sat on its poster. Check on scroll too.
    function liveCheck() {
      var r = root.getBoundingClientRect(), l = r.bottom > -300 && r.top < window.innerHeight + 300;
      if (l === live) return;
      live = l;
      root.classList.toggle('is-live', live);
      if (live) playClips(); else clips.forEach(function (v) { v.pause(); });
      if (typeof onLive === 'function') onLive(live);
    }
    window.addEventListener('scroll', liveCheck, { passive: true });
    window.addEventListener('touchstart', liveCheck, { passive: true });
    root.addEventListener('click', liveCheck);
    window.addEventListener('resize', liveCheck);
    setTimeout(liveCheck, 80);
    setTimeout(liveCheck, 1200);

    dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); }); });
    tabs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    window.addEventListener('resize', function () { if (list && on >= 0) list.style.height = steps[on].offsetHeight + 'px'; });

    /* ================= flip: the page lock ================= */
    if (mode === 'flip') {
      var hold = (parseInt(root.getAttribute('data-step-scroll'), 10) || 60) / 100;
      var engaged = false, frozen = false, frozenY = 0, releasedAt = 0, lastY = window.scrollY;
      var acc = 0, lastWheel = 0, armed = true, nudgeTimer = 0;
      var touchY = null, touchDone = false;

      function size() {
        // Track = the stage's own height + a hold zone, so the stage stays pinned while a shopper scrolls back up through it.
        track.style.height = Math.round(stage.offsetHeight + window.innerHeight * hold) + 'px';
      }
      function nudge(px) {
        stage.style.setProperty('--sgs-nudge', Math.max(-14, Math.min(14, px)) + 'px');
        clearTimeout(nudgeTimer);
        nudgeTimer = setTimeout(function () { stage.style.setProperty('--sgs-nudge', '0px'); }, GAP);
      }
      function freeze(y) {
        // Pin the whole page at y: no momentum, no address-bar bounce, nothing can carry the shopper past the stage.
        if (frozen) return;
        frozen = true; frozenY = Math.round(y);
        var html = document.documentElement, body = document.body;
        html.classList.add('sgs-locked');
        html.style.overflowY = 'scroll'; // keep the scrollbar's gutter so the page doesn't widen
        body.style.position = 'fixed'; body.style.top = -frozenY + 'px'; body.style.left = '0'; body.style.right = '0'; body.style.width = '100%';
      }
      function unfreeze() {
        if (!frozen) return;
        frozen = false;
        var html = document.documentElement, body = document.body;
        body.style.position = ''; body.style.top = ''; body.style.left = ''; body.style.right = ''; body.style.width = '';
        html.style.overflowY = '';
        html.classList.remove('sgs-locked');
        window.scrollTo({ top: frozenY, behavior: 'auto' });
        lastY = frozenY;
      }
      function unlock() {
        engaged = false;
        root.classList.remove('is-locked');
        stage.style.setProperty('--sgs-nudge', '0px');
        unfreeze();
      }
      function engage() {
        if (engaged) return;
        engaged = true;
        acc = 0; armed = true;
        root.classList.add('is-locked');
        freeze(trackPos().top);
      }
      function release(where) {
        unlock();
        releasedAt = performance.now();
        var r = root.getBoundingClientRect(), target;
        if (where === 'down') target = window.scrollY + r.bottom; // the next section's top meets the top of the screen
        else target = Math.max(0, window.scrollY + r.top - window.innerHeight); // the story drops below the screen
        window.scrollTo({ top: Math.round(target), behavior: reduce ? 'auto' : 'smooth' });
      }
      function flip(dir) {
        if (dir > 0) { if (on < n - 1) show(on + 1); else release('down'); }
        else { if (on > 0) show(on - 1); else release('up'); }
      }
      function onScroll() {
        if (frozen) return;
        var y = window.scrollY, down = y > lastY;
        lastY = y;
        if (!live || engaged) return;
        var p = trackPos();
        if (down && p.y >= 0 && p.y <= p.travel && performance.now() - releasedAt > SETTLE) engage();
      }
      function onWheel(e) {
        if (!engaged) return;
        e.preventDefault();
        var now = performance.now();
        if (now - lastWheel > GAP) { acc = 0; armed = true; }
        lastWheel = now;
        if (!armed) return;
        acc += wheelDelta(e);
        nudge(-acc * 0.12);
        if (Math.abs(acc) >= WHEEL_FLIP) { armed = false; var d = acc > 0 ? 1 : -1; acc = 0; nudge(0); flip(d); }
      }
      function onTouchStart(e) {
        if (!engaged || e.touches.length !== 1) { touchY = null; return; }
        touchY = e.touches[0].clientY; touchDone = false;
      }
      function onTouchMove(e) {
        if (!engaged || touchY === null) return;
        if (e.cancelable) e.preventDefault();
        var dy = touchY - e.touches[0].clientY;
        if (!touchDone) nudge(-dy * 0.12);
        if (!touchDone && Math.abs(dy) >= SWIPE_FLIP) { touchDone = true; nudge(0); flip(dy > 0 ? 1 : -1); }
      }
      function onTouchEnd() { touchY = null; stage.style.setProperty('--sgs-nudge', '0px'); }
      function onKey(e) {
        if (!engaged || typing() || e.altKey || e.ctrlKey || e.metaKey) return;
        var k = e.key, space = k === ' ' || k === 'Spacebar';
        if (k === 'ArrowDown' || k === 'PageDown' || (space && !e.shiftKey)) { e.preventDefault(); flip(1); }
        else if (k === 'ArrowUp' || k === 'PageUp' || (space && e.shiftKey)) { e.preventDefault(); flip(-1); }
      }

      size();
      show(0, true);
      onLive = function (isLive) { if (isLive) { size(); onScroll(); } else if (engaged) unlock(); };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('wheel', onWheel, { passive: false });
      window.addEventListener('touchstart', onTouchStart, { passive: true });
      window.addEventListener('touchmove', onTouchMove, { passive: false });
      window.addEventListener('touchend', onTouchEnd, { passive: true });
      window.addEventListener('touchcancel', onTouchEnd, { passive: true });
      window.addEventListener('keydown', onKey);
      window.addEventListener('resize', size);
      if ('ResizeObserver' in window) new ResizeObserver(function () { if (!frozen) size(); }).observe(stage);
      window.addEventListener('pagehide', unfreeze);
      if (skip) skip.addEventListener('click', function (e) {
        e.preventDefault();
        if (engaged) { release('down'); return; }
        var r = root.getBoundingClientRect();
        window.scrollTo({ top: Math.round(window.scrollY + r.bottom), behavior: reduce ? 'auto' : 'smooth' });
      });
      [].forEach.call(root.querySelectorAll('.sgs__btn'), function (b) { b.addEventListener('click', function () { if (engaged) { engaged = false; root.classList.remove('is-locked'); unfreeze(); } }); });
      lastY = window.scrollY;
      onScroll();
      root.addEventListener('shopify:block:select', function (e) {
        var s = e.target.closest('[data-sgs-step]'), i = steps.indexOf(s);
        if (i < 0) return;
        show(i);
        if (!engaged) { var p = trackPos(); if (p.y < 0 || p.y > p.travel) window.scrollTo({ top: Math.round(p.top), behavior: 'smooth' }); }
      });
      return;
    }

    /* ================= deck: swipe, arrows, Next ================= */
    if (mode === 'deck') {
      var sx = null, sy = null;
      function go(d) { var i = on + d; if (i >= 0 && i < n) show(i); }
      [].forEach.call(root.querySelectorAll('[data-sgs-prev]'), function (b) { b.addEventListener('click', function () { go(-1); }); });
      [].forEach.call(root.querySelectorAll('[data-sgs-next]'), function (b) { b.addEventListener('click', function () { go(1); }); });
      if (nextBtn) nextBtn.addEventListener('click', function () { go(1); });
      if (art) {
        art.addEventListener('touchstart', function (e) { if (e.touches.length === 1) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; } else sx = null; }, { passive: true });
        art.addEventListener('touchend', function (e) {
          if (sx === null) return;
          var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
          sx = null;
          if (Math.abs(dx) >= SWIPE_DECK && Math.abs(dx) > Math.abs(dy) * 1.2) go(dx < 0 ? 1 : -1);
        }, { passive: true });
      }
      root.addEventListener('keydown', function (e) {
        if (typing()) return;
        if (e.key === 'ArrowRight') { e.preventDefault(); go(1); } else if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
      });
      show(0, true);
      root.addEventListener('shopify:block:select', function (e) { var i = steps.indexOf(e.target.closest('[data-sgs-step]')); if (i >= 0) show(i); });
      return;
    }

    /* ================= stories: plays itself, tap to move ================= */
    if (mode === 'stories') {
      var DUR = (parseFloat(root.getAttribute('data-duration')) || 6) * 1000;
      var t0 = 0, paused = 0, pausedAt = 0, playing = false, done = false, raf = 0;
      function seg() { return segs[on] && segs[on].firstElementChild; }
      function start() {
        if (reduce || done) return;
        t0 = performance.now(); paused = 0; pausedAt = 0; playing = true;
        cancelAnimationFrame(raf); raf = requestAnimationFrame(tick);
      }
      function stop() { playing = false; cancelAnimationFrame(raf); }
      function tick(now) {
        if (!playing) return;
        if (pausedAt) { raf = requestAnimationFrame(tick); return; }
        var p = Math.min(1, (now - t0 - paused) / DUR), s = seg();
        if (s) s.style.width = (p * 100).toFixed(2) + '%';
        if (p >= 1) { if (on < n - 1) show(on + 1); else { done = true; stop(); root.classList.add('is-done'); } return; }
        raf = requestAnimationFrame(tick);
      }
      function pause() { if (playing && !pausedAt) pausedAt = performance.now(); }
      function resume() { if (pausedAt) { paused += performance.now() - pausedAt; pausedAt = 0; } }
      onShow = function () { done = false; root.classList.remove('is-done'); if (live) start(); };
      onLive = function (isLive) { if (isLive) { if (!playing && !done) start(); else resume(); } else pause(); };
      [].forEach.call(root.querySelectorAll('[data-sgs-prev]'), function (b) { b.addEventListener('click', function () { if (on > 0) show(on - 1); else start(); }); });
      [].forEach.call(root.querySelectorAll('[data-sgs-next]'), function (b) { b.addEventListener('click', function () { if (on < n - 1) show(on + 1); }); });
      if (art) {
        art.addEventListener('pointerdown', pause);
        window.addEventListener('pointerup', resume);
        window.addEventListener('pointercancel', resume);
      }
      document.addEventListener('visibilitychange', function () { if (document.hidden) pause(); else resume(); });
      show(0, true);
      root.addEventListener('shopify:block:select', function (e) { var i = steps.indexOf(e.target.closest('[data-sgs-step]')); if (i >= 0) { show(i, true); stop(); if (seg()) seg().style.width = '100%'; } });
      return;
    }
  }

  function boot() { [].forEach.call(document.querySelectorAll('[data-sgs]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
